import React from 'react';
import cx from 'classnames';
import { LinkTo } from '../LinkTo';
import { useDragonKitValue } from '../../context/DragonKitContext';

var NavHeader = function NavHeader(_ref) {
  var Logo = _ref.Logo,
      children = _ref.children;

  var _useDragonKitValue = useDragonKitValue(),
      dragonKit = _useDragonKitValue[0];

  var classes = cx('nav-header', dragonKit.theme);
  return /*#__PURE__*/React.createElement("header", {
    className: classes
  }, /*#__PURE__*/React.createElement("div", {
    className: "middle"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, /*#__PURE__*/React.createElement(LinkTo, {
    type: "route",
    url: "/"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "logo"
  }, Logo && /*#__PURE__*/React.createElement(Logo, null))), children)));
};

NavHeader.displayName = 'NavHeader';
var NavHeaderDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  NavHeaderDoc = require('./doc').doc(NavHeader);
}

var NavHeaderWrapper = NavHeaderDoc || NavHeader;
export { NavHeaderWrapper as NavHeader };